import React, { useState, useEffect } from 'react';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const licenseTypes = ['All', 'SuperPos', 'Lieferando'];
const activeStatuses = ['All', 'Active', 'Inactive'];

function FilterBar({ allLicenses, setLicenses }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLicenseType, setSelectedLicenseType] = useState('All');
  const [selectedActiveStatus, setSelectedActiveStatus] = useState('All');

  useEffect(() => {
    handleFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, selectedLicenseType, selectedActiveStatus]);

  const handleFilter = () => {
    let filtered = [...allLicenses];

    // Filter by owner name
    if (searchQuery) {
      filtered = filtered.filter((l) =>
        l.owner?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Filter by product
    if (selectedLicenseType !== 'All') {
      filtered = filtered.filter((l) => l.product === selectedLicenseType);
    }

    // Filter by active/inactive
    if (selectedActiveStatus !== 'All') {
      const isActive = selectedActiveStatus === 'Active';
      filtered = filtered.filter((l) => l.isActive === isActive);
    }

    setLicenses(filtered);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleLicenseTypeChange = (e) => {
    setSelectedLicenseType(e.target.value);
  };

  const handleActiveStatusChange = (e) => {
    setSelectedActiveStatus(e.target.value);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextField
          label="Search Owner"
          fullWidth
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </Grid>

      <Grid item xs={6} md={4}>
        <FormControl fullWidth>
          <InputLabel>Product</InputLabel>
          <Select
            value={selectedLicenseType}
            label="Product"
            onChange={handleLicenseTypeChange}
          >
            {licenseTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={6} md={4}>
        <FormControl fullWidth>
          <InputLabel>Status</InputLabel>
          <Select
            value={selectedActiveStatus}
            label="Status"
            onChange={handleActiveStatusChange}
          >
            {activeStatuses.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default FilterBar;
